var _style, _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVegetableBroth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6393D;}\n\t.st1{fill:#2A384F;}\n\t.st2{fill:#F8EEE1;}\n\t.st3{fill:#77B155;}\n\t.st4{fill:#EF9062;}\n\t.st5{fill:#B6D5E7;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.53,185.61c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.24,151.31,61.84,185.61,104.53,185.61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.7,148.41c-40.47,0-45.99-37.84-45.99-47.93h91.99C146.69,105.53,141.4,148.41,100.7,148.41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.69,99.54c0-10.15-20.59-18.39-45.99-18.39c-25.4,0-45.99,8.23-45.99,18.39c0,0.03,0.01,0.06,0.01,0.09 c0,0.04-0.01,0.06-0.01,0.1c0,10.15,20.59,18.39,45.99,18.39c25.4,0,45.99-8.23,45.99-18.39c0-0.03-0.01-0.06-0.01-0.09 C146.68,99.6,146.69,99.57,146.69,99.54z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.98,101.84c0-8.89-18.03-16.1-40.28-16.1c-22.25,0-40.28,7.21-40.28,16.1c0,0.03,0.01,0.05,0.01,0.08 c0,0.03-0.01,0.06-0.01,0.09c0,8.89,18.03,16.1,40.28,16.1c22.25,0,40.28-7.21,40.28-16.1c0-0.03-0.01-0.05-0.01-0.08 C140.97,101.9,140.98,101.88,140.98,101.84z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.9,124.25c5.36-3.22,6.68-12.61,5.61-11.53c1.07-1.07-8.57,0-11.78,5.36c0-2.14-2.14-10.71-5.36-3.21 c-3.22,7.5-2.14,8.57-2.14,10.71c0,2.14,4.29,2.14,4.29,2.14s-0.19,4.1,1.95,4.1c2.14,0,3.03,0.88,10.52-2.33 C161.49,126.26,153.05,124.25,150.9,124.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M137.76,146.46c-11.54,11.54-30.53,19.82-33.21,17.14c-2.68-2.68,5.6-21.67,17.14-33.21 c11.54-11.54,17.47-11.46,22.5-6.43C149.22,128.99,149.3,134.92,137.76,146.46"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M149.11,73.31l-29.53,29.53c-1.26,1.26-3.32,1.26-4.58,0l-0.99-0.99c-1.26-1.26-1.26-3.32,0-4.58l29.53-29.53 c1.26-1.26,3.32-1.26,4.58,0l0.99,0.99C150.37,69.99,150.37,72.05,149.11,73.31z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -40.556 110.13)",
    className: "st5",
    cx: 112.66,
    cy: 104.02,
    rx: 11.98,
    ry: 11.16
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.21,102.29c5.68-3.87,17.28,8.58,32.01,0.72c14.74-7.85-1.33,11.36-1.33,11.36l-20.3,2.78L93.21,102.29z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M98.76,72.35c0.29,0.36,0.72,0.54,1.15,0.54c0.33,0,0.66-0.11,0.93-0.33c0.63-0.52,0.73-1.45,0.21-2.08 c-0.17-0.2-4.06-5.08,0.03-10.17c4.51-5.62,1.92-10.98-0.08-13.03c-0.57-0.58-1.49-0.59-2.08-0.03c-0.59,0.56-0.6,1.5-0.04,2.09 c0.4,0.42,3.8,4.26-0.1,9.12C94.32,64.01,96.82,69.97,98.76,72.35z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M110.55,74.6c0.29,0.36,0.72,0.54,1.15,0.54c0.33,0,0.66-0.11,0.93-0.33c0.63-0.52,0.73-1.45,0.21-2.08 c-0.09-0.11-2.19-2.74,0.02-5.5c3.01-3.75,1.26-7.35-0.08-8.73c-0.56-0.58-1.49-0.59-2.07-0.03c-0.59,0.56-0.61,1.49-0.05,2.08 c0.34,0.36,1.93,2.3-0.09,4.83C107.6,69.06,109.26,73.02,110.55,74.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M86.3,74.6c0.29,0.36,0.72,0.54,1.15,0.54c0.33,0,0.66-0.11,0.93-0.33c0.63-0.52,0.73-1.45,0.21-2.08 c-0.09-0.11-2.19-2.74,0.02-5.5c3.01-3.75,1.26-7.35-0.08-8.73c-0.57-0.58-1.51-0.6-2.09-0.03c-0.58,0.57-0.6,1.51-0.03,2.09 c0.08,0.09,2.04,2.15-0.1,4.82C83.35,69.06,85.01,73.02,86.3,74.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M105,110.7c-0.02-1.45,0.6-2.9,1.67-3.89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetableBroth);
export default __webpack_public_path__ + "static/media/Vegetable_broth.5038e6f4836403cd6cf550f3acc83b04.svg";
export { ForwardRef as ReactComponent };